// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox__Checkbox___FgXpj","errorItem":"Checkbox__errorItem___bS0_9"};